import { JsonViewer } from '@textea/json-viewer';

import {
    Modal,
    Icon,
    Button,
} from 'semantic-ui-react'

export function JsonModal({ header, jsonContent }) {

    return (
        <Modal
            closeIcon
            trigger={<span><Button size='mini' compact icon><Icon name='code' /> Show JSON Response</Button></span>}
            header={header}
            content={<div className="content"><JsonViewer value={jsonContent} /></div>}
            scrolling={true}
        />
    )
}